export default "__VITE_ASSET___FMqnGj5__"